import React from "react";
import { AccessoriesGroupModel, AccessoriesModel } from "../models/AccessoriesModel";
import { MediaType } from "../models/MediaType";
import FeatureCards from "./FeatureCards";
import uniq from "lodash/uniq";
import each from "lodash/each";

interface AccessoriesState {
  filter: string;
}

interface AccessoriesProps {
  content: AccessoriesGroupModel;
}

class Accessories extends React.Component<AccessoriesProps, AccessoriesState> {
  categories: string[] = [];

  get filteredAccessories(): AccessoriesModel[] {
    const { individual } = this.props.content;
    const { filter } = this.state;

    if (!filter) return individual;

    return individual.filter(item => {
      return item.category.toLowerCase() === this.state.filter.toLowerCase();
    });
  }

  constructor(props: AccessoriesProps) {
    super(props);

    this.state = {
      filter: null
    };

    this.selectItem = this.selectItem.bind(this);
    this.setFilter = this.setFilter.bind(this);

    this.categories = uniq(
      props.content.individual.map(item => {
        return item.category;
      })
    );
    this.categories.unshift("All");
  }

  selectItem(item: AccessoriesModel): void {
    let disclaimersText = "";
    const priceDisclaimer =
      "<p class='highlight__disclaimer'>Price is Subaru Australia’s Special Fitted Recommended Price. Actual price may vary between retailers. Ask your retailer for their final price. Fitted RRP is the Recommended Retail Price. The Fitted RRP includes the price of the accessory item (excluding government stamp duty), installation (if necessary) and painting (if necessary). Government stamp duty charges will appear in the Driveaway price of the vehicle after they have been added to the vehicle.</p>";

    if (item.disclaimers.length > 0) {
      each(item.disclaimers, function(value) {
        disclaimersText = disclaimersText.concat(`<p class="highlight__disclaimer">${value}</p>`);
      });
    }

    disclaimersText = disclaimersText.concat(priceDisclaimer);
    const text = `<p>${item.text}<p>${disclaimersText}`;

    const selectedItem = {
      media: item.media,
      title: item.title,
      text: text,
      slides: item.slides || null,
      type: item.type || MediaType.Image
    };

    const evt = new CustomEvent("showMediaModal", { detail: { content: [selectedItem] } });
    window.dispatchEvent(evt);
  }

  setFilter(filter: string): void {
    this.setState({ filter });
  }

  render() {
    const { content } = this.props;

    return (
      <div className="accessory__wrap">
        <h2 className="text-center">Accessory Packs</h2>
        <FeatureCards content={content.packs} itemClassName="accessory__item" />

        <h2 className="text-center">Individual Accessories</h2>
        <div className="accessory__itemsFilter">
          <div className="form__select-container">
            <select
              className="form__select"
              onChange={e => {
                e.preventDefault();
                this.setFilter(e.target.value);
              }}
              value={this.state.filter || ""}
            >
              {this.categories.map((item: string, i: number) => {
                return (
                  <option value={i === 0 ? "" : item} key={`option_${i}`}>
                    {item}
                  </option>
                );
              })}
            </select>
          </div>
          <div className="accessory__itemsCount">{this.filteredAccessories.length} ITEMS</div>
        </div>
        <ul className={`accessory__items accessory__items--centered accessory__items--individual`}>
          {this.filteredAccessories.map(
            (cardContent: AccessoriesModel, i: number): any => {
              return (
                <li key={`card__${i}`} className="accessory__item accessory__item--individual">
                  <div
                    className="accessory__inner"
                    onClick={e => {
                      e.preventDefault();
                      this.selectItem(cardContent);
                    }}
                  >
                    <div
                      className="accessory__image"
                      style={{ backgroundImage: `url("${cardContent.thumbnail}")` }}
                    />
                    <div className="accessory__copy">
                      {cardContent.title ? (
                        <h4 className="accessory__title">{cardContent.title}</h4>
                      ) : null}

                      {cardContent.text ? (
                        <div
                          className="accessory__text"
                          dangerouslySetInnerHTML={{ __html: cardContent.text }}
                        />
                      ) : null}
                    </div>
                  </div>
                </li>
              );
            }
          )}
        </ul>
      </div>
    );
  }
}

export default Accessories;
